/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type MutationResult = "failure" | "skipped" | "success" | "%future added value";
export type participantNotesDeleteMutationVariables = {
    readonly participant_id: string;
    readonly case_manager_id: string;
    readonly participant_note_id: string;
};
export type participantNotesDeleteMutationResponse = {
    readonly deleteParticipantNote: ({
        readonly participant: ({
            readonly id: string;
            readonly name: {
                readonly first: string;
                readonly last: string | null;
            };
            readonly notes: ReadonlyArray<({
                readonly id: string;
                readonly label: string;
                readonly created_at: string;
                readonly updated_at: string | null;
                readonly case_manager: ({
                    readonly id: string;
                    readonly name: {
                        readonly first: string;
                        readonly last: string | null;
                    };
                }) | null;
            }) | null> | null;
        }) | null;
        readonly result: MutationResult;
        readonly description: string | null;
        readonly errors: ReadonlyArray<string | null> | null;
    }) | null;
};
export type participantNotesDeleteMutation = {
    readonly response: participantNotesDeleteMutationResponse;
    readonly variables: participantNotesDeleteMutationVariables;
};



/*
mutation participantNotesDeleteMutation(
  $participant_id: String!
  $case_manager_id: String!
  $participant_note_id: String!
) {
  deleteParticipantNote(participant_id: $participant_id, case_manager_id: $case_manager_id, participant_note_id: $participant_note_id) {
    participant {
      id
      name {
        first
        last
      }
      notes {
        id
        label
        created_at
        updated_at
        case_manager {
          id
          name {
            first
            last
          }
        }
      }
    }
    result
    description
    errors
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "participant_id",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "case_manager_id",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "participant_note_id",
            "type": "String!",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "name",
        "storageKey": null,
        "args": null,
        "concreteType": "PersonName",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "first",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "last",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v3 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "deleteParticipantNote",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "case_manager_id",
                    "variableName": "case_manager_id"
                },
                {
                    "kind": "Variable",
                    "name": "participant_id",
                    "variableName": "participant_id"
                },
                {
                    "kind": "Variable",
                    "name": "participant_note_id",
                    "variableName": "participant_note_id"
                }
            ],
            "concreteType": "NewParticipant",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "participant",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Participant",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        (v2 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "notes",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ParticipantNote",
                            "plural": true,
                            "selections": [
                                (v1 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "label",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "created_at",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "updated_at",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "case_manager",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "CaseManager",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        (v2 /*: any*/)
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "result",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "description",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "errors",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "participantNotesDeleteMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v3 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "participantNotesDeleteMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v3 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "participantNotesDeleteMutation",
            "id": null,
            "text": "mutation participantNotesDeleteMutation(\n  $participant_id: String!\n  $case_manager_id: String!\n  $participant_note_id: String!\n) {\n  deleteParticipantNote(participant_id: $participant_id, case_manager_id: $case_manager_id, participant_note_id: $participant_note_id) {\n    participant {\n      id\n      name {\n        first\n        last\n      }\n      notes {\n        id\n        label\n        created_at\n        updated_at\n        case_manager {\n          id\n          name {\n            first\n            last\n          }\n        }\n      }\n    }\n    result\n    description\n    errors\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'fbd12da3e4520df5dde0cb8ab75f6157';
export default node;
